import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Config } from 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subject } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { ActionType, ITable, TableRequest } from 'src/app/model/table.model';

@Component({
    selector: 'app-monthly-list',
    templateUrl: './monthly-list.component.html',
    styleUrl: './monthly-list.component.css',
    standalone: false
})
export class MonthlyListComponent {
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };  
  dtOptions: Config = {};
  dtTrigger: Subject<any> = new Subject<any>();
  closeResult = '';
  model:any = {};
  rows: any;



  constructor(private route: ActivatedRoute,private loader: LoadingBarService, private http: HttpClient,private apiService: ApiServiceListService, private router: Router,private modalService: NgbModal,  private toastr: ToastrService) {
  }



  @ViewChild('itemDeleteModal') itemDeleteModal!: any;
  currentModuleName = this.route.snapshot.data['module'];
    columnList = [];
    tableData = [];
    pageInfo: TableRequest = {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      filteredValue: [],
      searchValue: '',
      sortColumn: '',
      sortOrder: 'asc'
    }
    actionItems: ActionType[] = [];
    filterFields = [];
    actionType = ActionType;
  
    pageInfoChange(data) {
      this.pageInfo = data;
      this.getMonthlyPack();
    }
  
  
    getMonthlyPackFullDetails() {
      const filterInfo$ = this.apiService.getMonthlyPackFilterDetails();
      const getMonthlyList$ = this.apiService.getMonthlyPackAPI({ body: this.pageInfo });
  
      // Combine both observables
      forkJoin([filterInfo$, getMonthlyList$]).subscribe(
        {
          next: ([filterInfo, tableData]) => {
            if (filterInfo) {
              this.filterFields = filterInfo.data.filterFields;
              this.actionItems = filterInfo.data.actionItems;
              this.columnList = filterInfo.data.columnList;
            }
            if (tableData) {
              this.tableData = tableData.data.tableData;
              this.pageInfo.totalCount = tableData.data.pageInfo.totalCount;
            }
          },
          error: (error) => {
            console.error('Error:', error);
          }
        }
      );
    }
  
  
    getMonthlyPack() {
      let parameter: any = {
        body: this.pageInfo
      }
      this.loader.increment(35);
      this.apiService.getMonthlyPackAPI(parameter).subscribe({
        next: (value: ITable) => {
          // Handle emitted values
          if (value.data.tableData) {
            this.tableData = value.data.tableData;
            this.pageInfo.totalCount = value.data.pageInfo.totalCount;
  
          } else {
            this.tableData = [];
            this.pageInfo.totalCount = 0;    
          }
  
        },
        error: (error: any) => {
          // Handle errors
        },
        complete: () => {
          this.loader.complete();
        }
      });
    }
  
  
    actionEvent(data) {
      if (data.type == this.actionType.UPDATE) {
        this.editItem(data.value._id);
      }
      if (data.type == this.actionType.DELETE) {
        this.deleteItemCheck(this.itemDeleteModal, data.value._id);
      }
    }



  ngOnInit() {
    this.breadcrumb = {
      'mainlabel': 'Package',
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      //  paging:false
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search Package'
      }
    }
    this.getMonthlyPackFullDetails(); 

  }
  editItem(id:string){
    this.router.navigateByUrl('/monthlypass/update/' + id);
  }

  moveToAdd() {
    this.router.navigateByUrl('/monthlypass/create');
  }

  private getDismissReason(reason: any): string {
    console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  deleteItemCheck(itemDelModal:any,id) {
    let self = this;

    self.modalService.open(itemDelModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Ok click') {
        this.deleteItem(id);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  deleteItem(id) {
    let parameter: any = {
      methodType: "DELETE",
    }
    let body: any = {};
    body = { "_id" : id }

    this.apiService.deleteMonthlyAPI(parameter, body).subscribe((response: any) => {
      console.log(response);
      if (response.success) {
        this.toastr.success(response.message, '', {
          timeOut: 3000,
        });
        this.getMonthlyPack();
      } else {
        this.toastr.error(response.message, '', {
          timeOut: 3000,
        });
        
      }
    }, (error) => {

    });
  }

  

}
